module.exports = __webpack_public_path__ + "static/media/triplex_blue.2e99d704.svg";